<script setup lang="ts">
import { computed } from 'vue';
const { $api, $toast } = useNuxtApp();
const userStore = useUserStore();

const isVerified = computed(() => {
    return userStore.user?.email_verified_at;
});

const resendEmail = async () => {
    await $api.post('/verify-email').then(() => {
        $toast.success('Email sent');
    }).catch(() => {
        $toast.error('Failed to send email');
    });
}
</script>

<template>
    <div v-if="!isVerified"
        class="bg-zinc-100 dark:bg-zinc-900 border-b border-zinc-200 dark:border-zinc-700 flex items-center justify-center px-2 py-1.5">
        <div class="text-sm font-normal  text-zinc-800 dark:text-zinc-300 flex items-center gap-2">
            <div>We’ve sent a verification email. Didn’t get it?</div>
            <button class="btn btn-primary btn-sm" @click="resendEmail">Resend</button>
        </div>
    </div>
</template>